import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import RegisterScreen from "./RegisterScreen";
import LoginScreen from "./LoginScreen";
import { Button } from "react-native-paper";
import { useTranslation } from "react-i18next";
import ForgotPasswordScreen from "./ForgotPasswordScreen";
import { ThemeToggle } from "../../components/ThemeToggle";
import { AuthParamList } from "../../types/navigationParams";

const Stack = createNativeStackNavigator<AuthParamList>();

export default function AuthStack() {
  const { i18n, t } = useTranslation();

  const changeLanguage = async () => {
    const newLanguage = i18n.language === "ru" ? "kk" : "ru";
    await i18n.changeLanguage(newLanguage);
  };

  return (
    <Stack.Navigator
      screenOptions={{
        headerTitle: "",
        headerRight: () => <ThemeToggle />,
      }}
    >
      <Stack.Screen
        name="SignInScreen"
        component={LoginScreen}
        options={{
          headerTitle: t("Sign in"),
          headerLeft: () => (
            <Button onPress={changeLanguage}>
              {i18n.language === "kk" ? "Kaz" : "Rus"}
            </Button>
          ),
        }}
      />
      <Stack.Screen
        options={{
          headerTitle: t("Sign up"),
          headerBackButtonDisplayMode: "minimal",
        }}
        name="RegisterScreen"
        component={RegisterScreen}
      />
      <Stack.Screen
        options={{
          headerTitle: t("Forgot password"),
          headerBackButtonDisplayMode: "minimal",
        }}
        name="ForgotPasswordScreen"
        component={ForgotPasswordScreen}
      />
    </Stack.Navigator>
  );
}
